import { Flex, Typography } from "antd";
import { DisplayAmount, SquareIcon } from "ui";
import styles from "./balances-items.module.css";

export const BalanceItem = ({
  label,
  value,
  icon: IconComponent,
}: {
  label: string;
  value: number;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}) => {
  return (
    <Flex vertical className={styles.balanceItem}>
      <Typography.Text className={styles.balanceItemLabel}>{label}</Typography.Text>
      <Flex align="center" gap="4px">
        {IconComponent && <IconComponent />}
        <DisplayAmount amount={value} currency="RUB" />
      </Flex>
    </Flex>
  );
};

export const BalanceItemMain = ({
  label,
  value,
  icon: IconComponent,
}: {
  label: string;
  value: number;
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}) => {
  return (
    <Flex justify="space-between">
      <Flex vertical gap="8px">
        <Typography.Text type="secondary">{label}</Typography.Text>
        <DisplayAmount amount={value} currency="RUB" bold />
      </Flex>

      {IconComponent && <SquareIcon icon={IconComponent} size="2xl" squareSize="4xl" squareBg />}
    </Flex>
  );
};
